import React from 'react';
import classNames from 'classnames';
import { slugify, kbygPaths } from '@surfline/web-common';

import ScrollControl from 'components/ScrollControl';
import SpotListItem from 'components/SpotListItem';
import type { Taxonomy } from 'types/locationView';
import type { SpotsTravel } from 'types/spot';
import type { Units } from 'types/units';
import { showPremiumCamCTA } from 'utils/premiumCam';

import styles from './TopSpots.module.scss';

type Props = {
  taxonomy: Taxonomy;
  topSpots: SpotsTravel;
  units: Units;
  doSetTopSpotsPosition: (...args: any) => void;
  scrollLeft?: number;
  hasPremiumCamPermissions: boolean;
};

type State = {};

class TopSpots extends React.Component<Props, State> {
  // This ends up being a ref for an element
  spotList: any;

  componentDidUpdate() {
    const { scrollLeft } = this.props;
    this.spotList.scrollLeft = scrollLeft;
  }

  scrollLeft() {
    const { doSetTopSpotsPosition } = this.props;
    const left = this.spotList.scrollLeft - this.spotList.clientWidth;
    doSetTopSpotsPosition({ top: 0, left });
  }

  scrollRight() {
    const { doSetTopSpotsPosition } = this.props;
    const left = this.spotList.scrollLeft + this.spotList.clientWidth;
    doSetTopSpotsPosition({ top: 0, left });
  }

  render() {
    const { taxonomy, topSpots, units, hasPremiumCamPermissions } = this.props;
    return (
      <div className={classNames(styles.topSpots)}>
        <h3 className={styles.topSpotsTitle}>Top Surf Spots &amp; Beaches in {taxonomy.name}</h3>
        <div className={styles.topSpotsContainer}>
          <ScrollControl size="tall" direction="left" clickHandler={() => this.scrollLeft()} />
          <div
            ref={(el) => {
              this.spotList = el;
            }}
            className={styles.topSpotsList}
          >
            {topSpots.map((spot) => (
              <a key={spot.name} href={kbygPaths.spotReportPath(slugify(spot.name), spot._id)}>
                <SpotListItem
                  spot={spot}
                  units={units}
                  showPremiumCamCTA={showPremiumCamCTA({
                    spot,
                    hasPremiumCamPermissions,
                  })}
                  mobileCard
                />
              </a>
            ))}
          </div>
          <ScrollControl size="tall" direction="right" clickHandler={() => this.scrollRight()} />
        </div>
      </div>
    );
  }
}

// @ts-ignore
TopSpots.defaultProps = {
  scrollLeft: 0,
};

export default TopSpots;
